<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
                        <template slot="header">
                            <div class="header-content">
                                <button class="btn btn-primary btn-primary-add" @click="AddMaterial">
                                    <i class="fas fa-plus" style="font-weight: 900"></i>
                                </button>
                                <h4 class="card-title" style="display: inline-block; margin-right: 50%">
                                    قائمة الخامات
                                </h4>
                            </div>
                            <!-- <div class="search-bar">
                                <input type="text" style="
                      border: 1px solid lightgray;
                      border-radius: 5px;
                      padding: 1%;
                      width: 100%;
                      margin-bottom: 15px;
                    " placeholder="ما اسم الخامة التي تبحث عنها؟" v-model="searchKey" @input="performSearch" />
                            </div> -->
                        </template>
                        <p v-if="table1.data.length == 0" style="text-align: center;">لا توجد خامة بهذا الاسم</p>
                        <table v-else class="table-hover table-striped tableStyle" style="width: 100%">
                            <thead>
                                <tr>
                                    <th v-for="(column, index) in table1.columns" :key="index"
                                        :class="{ hiddenCol: column === 'الرقم التسلسلي' }">
                                        {{ column }}
                                    </th>
                                    <th>الإجراءات</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, rowIndex) in table1.data" :key="rowIndex">
                                    <td class="hiddenCol">{{ row["الرقم التسلسلي"] }}</td>
                                    <td>{{ row["الاسم"] }}</td>
                                    <td>{{ row["الاسم بالإنجليزية"] }}</td>
                                    <td>
                                        <button class="btn btn-primary btn-primary-add">
                                            <!-- @click="editCategory(row['الرقم التسلسلي'])"> -->
                                        </button>
                                        <!-- <button class="btn btn-danger" @click="deleteCategory(row['الرقم التسلسلي'])"> -->
                                        <button class="btn btn-danger m-auto" @click="deleteMaterial(row['الرقم التسلسلي'])">
                                            <i class="fas fa-trash-alt icon-danger"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </card>
                </div>
            </div>
        </div>
        <nav v-if="table1.totalPages > 1">
            <ul class="pagination justify-content-center">
                <li class="page-item" v-for="page in table1.totalPages" :key="page"
                    :class="{ active: table1.currentPage === page }">
                    <a class="page-link" @click="changePage(page)">{{ page }}</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import Axios from "../../../Axios";
import Swal from "sweetalert2";
import LTable from "src/Dashboard/SharedComponents/Table.vue";
import Card from "src/Dashboard/SharedComponents/Card.vue";
import AddMaterial from "src/Dashboard/pages/Materials/AddMaterial.vue";

const tableColumns = [ "الاسم بالعربية", "الاسم بالإنجليزية", "الرقم التسلسلي"];

export default {
    components: {
        LTable,
        Card,
        AddMaterial,
    },
    data() {
        return {
            table1: {
                columns: [...tableColumns],
                data: [],
                currentPage: 1,
                totalPages: 1,
            },
            searchKey: "",
        };
    },
    methods: {
        performSearch() {
            Axios.get(`/dashboard/materials/`, {
                params: { searchkey: this.searchKey, limit: 6 },

            })
                .then((response) => {
                    // console.log(response.data);
                    this.table1.data = response.data.map((material) => {
                        const row = {
                            الاسم: material.name_ar + " ",
                            "الاسم بالإنجليزية": material.name,
                            "الرقم التسلسلي": material.id,
                            loading: true,
                        };
                        return row;
                    });
                    this.table1.totalPages = response.data.totalPages;
                })
                .catch((error) => {
                    this.table1.data = [];
                    // console.error(error);
                });
        },
         deleteMaterial(id) {
             Swal.fire({
                 title: "هل أنت متأكد؟",
                 text: "هل تريد حقًا حذف هذه الخامة",
                 icon: "warning",
                 showCancelButton: true,
                 confirmButtonText: "نعم",
                 cancelButtonText: "إلغاء",
                 dangerMode: true,
             }).then((result) => {
                 if (result.isConfirmed) {
                     Axios.delete(`/dashboard/material/${id}`)
                         .then((response) => {
                             this.table1.data = this.table1.data.filter(
                                 (row) => row["الرقم التسلسلي"] !== id
                             );
                             Swal.fire("تم الحذف!", "تم حذف الخامة بنجاح.", "success");
                         })
                         .catch((error) => {
                             // console.error(error);
                             Swal.fire("خطأ!", "حدث خطأ أثناء الحذف.", "error");
                         });
                 }
             });
         },
         AddMaterial() {
             this.$router.push("/admin/add-material");
         },
        // changePage(page) {
        //     this.table1.currentPage = page;
        //     this.fetchData();
        // },
        fetchData() {
            Axios.get("/dashboard/materials")
                .then((response) => {
                    this.table1.data = response.data.map((material) => {
                        const row = {
                            الاسم: material.name_ar + " ",
                            "الاسم بالإنجليزية": material.name,
                            "الرقم التسلسلي": material.id,
                            loading: true,
                        };
                        return row;
                    });
                    this.table1.totalPages = response.data.totalPages;
                })
                .catch((error) => {
                    // console.error(error);
                });
        },
        // editCategory(id) {
        //     this.$router.push(`/admin/edit-category/${id}`);
        // },
    },
    mounted() {
        this.fetchData();
    },
};
</script>

<style>
.tableStyle {
    text-align: center;
}

.hiddenCol {
    display: none;
}

tr {
    border-bottom: 1px solid rgb(207, 205, 205);
}

td {
    padding: 10px;
}

th {
    padding-bottom: 15px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 47%;
    margin-bottom: 20px;
}

.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
</style>